import React from 'react';

import { Box, Button, Typography, Paper } from '@mui/material';

import type { FallbackProps } from 'react-error-boundary';

import styles from './ErrorFallback.module.scss';

export const ErrorFallback: React.FC<FallbackProps> = ({ error, resetErrorBoundary }) => (
  <Box className={styles.errorFallbackContainer}>
    <Paper className={styles.errorFallbackPaper}>
      <Typography className={styles.errorFallbackTitle}>
        Something went wrong
      </Typography>
      <Typography className={styles.errorFallbackMessage}>
        {error.message}
      </Typography>
      <Button onClick={resetErrorBoundary}>
        Try again
      </Button>
    </Paper>
  </Box>
);
